import ErrorUtils from "~/utils/error_utils";

export default {
    checkEmailAddress(payload)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/register/check-email',
                data: payload,
                method: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    createNewAccount(payload)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/register/form',
                data: payload,
                method: 'POST',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    updateUserAccount(payload)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/register/update',
                data: payload,
                method: 'POST',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getFormData()
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/register/form-dt',
                method: 'GET',
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    saveUserImage(payload)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/register/save-image',
                method: 'POST',
                data: payload,
                global: false
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    }
}